export const TILL_NOW = 'TILL_NOW';